import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { SlideDown } from 'react-slidedown'
import config from '../../config'
import {
  ContainerDivs,
  PillarScore,
  LinkIcon
} from '../'
import Styles from './KpiList.css'


@CSSModules(Styles, {allowMultiple:true})
export default class KpiList extends Component {
  static propTypes = {
    issueId: PropTypes.string.isRequired,
    fund: PropTypes.object
  }
  constructor(props){
    super(props)
    const gradeLabels = {
      gef: 'gender_equality',
      dei: 'dei',
      rji: 'rji',
      hrc: 'hrc',
    }
    this.state = {
      gradeLabels,
      alphabet: ['a','b','c','d','e','f','g'],
      pillarsConfig: config.sjfKpiConfig[props.issueId] || null,
      scoreNormalizers: config[props.issueId+'ScoreNormalizers'],
      pillarsOpen: {},
    }
  }
  /**
   * On click, updates state to open a pillar slidedown.
   * 
   * @param {number} pillarIndex - Index of the pillar to open/close in the
   * pillar config.
   */
  openPillar(pillarIndex) {
    this.setState(prevState => ({
      pillarsOpen: Object.assign({}, prevState.pillarsOpen, {
        [pillarIndex]: !prevState.pillarsOpen[pillarIndex]
      })
    }))
  }
  //
  render() {
    if (
      !this.state.pillarsConfig ||
      this.props.fund['grade_'+this.state.gradeLabels[this.props.issueId]] === 2.5
    ) {
      return null
    }
    //
    return <section
      styleName={'kpi-list-component-wrap-' + this.props.issueId}
    >
      <ContainerDivs>
        <div styleName='kpi-list-section'>
          <h2>Sub-scores & KPIs</h2>
          {
            this.state.pillarsConfig.map((pE, pI) => {
              const pillarLetter = this.state.alphabet[pI]
              const pillarTitle = pE[0]
              const pillarDescription = pE[1]
              // const pillarPoints = pE[2]
              const pillarKpis = pE[3]
              const buttonStyle = this.state.pillarsOpen[pI] ?
                'kpi-list-btn active' :
                'kpi-list-btn'
              return <div key={`${this.props.issueId}-${pI}`} styleName='kpi-list-wrap'>
                <div
                  onClick={ () => { this.openPillar(pI) } }
                  styleName={buttonStyle}
                >
                  <div>
                    <h3>{pillarTitle}</h3> { /* {pI+1}. */ }
                  </div>
                  {
                    this.props.fund ?
                      <PillarScore
                        fund={this.props.fund}
                        issueId={this.props.issueId}
                        pillarId={pillarLetter}
                      /> :
                      null
                  }
                  <div styleName='kpi-list-btn-icon'>
                    <LinkIcon
                      faclass={
                        this.state.pillarsOpen[pI] ?
                          'fa-angle-up' :
                          'fa-angle-down'
                      }
                    />
                  </div>
                </div>
                <SlideDown>
                  {
                    this.state.pillarsOpen[pI] ?
                      <div styleName='kpi-list-open'>
                        <p>{pillarDescription}</p>
                        <ul>
                          {
                            pillarKpis.map((kE, kI) => {
                              const kpiTitle = kE[0]
                              const kpiDescription = kE[1]
                              return <li
                                key={`${this.props.issueId}-${pI}-${kI}`}
                              >
                                <p>
                                  <b>{kpiTitle}</b><br/>
                                  {kpiDescription}
                                </p>
                              </li>
                            })
                          }
                        </ul>
                      </div> :
                      null
                  }
                </SlideDown>
              </div>
            })
          }
        </div>
      </ContainerDivs>
    </section>
  }
}
